import React from 'react'
import styled from 'styled-components'
import { Spacings, Text } from '@styles'

const PillContainer = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: fit-content;
	gap: ${Spacings.SPACING_1B};
	padding: ${({ $size }) => {
		if ($size === 'small') return `${Spacings.SPACING_1B} ${Spacings.SPACING_2B}`
		if ($size === 'large') return `${Spacings.SPACING_2B} ${Spacings.SPACING_4B}`
		return `${Spacings.SPACING_1B} ${Spacings.SPACING_3B}`
	}};
	font-size: ${({ $size }) => {
		if ($size === 'small') return Text.EXTRA_SMALL
		if ($size === 'large') return Text.MEDIUM
		return Text.SMALL
	}};
	font-weight: ${Text.BOLD_600};
	border-radius: ${({ theme, $round }) => ($round ? theme.radius.full : theme.radius.sm)};
	// line-height: 1;
	white-space: nowrap;

	background-color: ${({ theme, $color, $variant }) => {
		const statusColor = theme.colors.status[$color] || theme.colors.status.neutral
		if ($variant === 'solid') return statusColor.icon || statusColor.text
		if ($variant === 'outline') return 'transparent'
		return statusColor.bg
	}};

	color: ${({ theme, $color, $variant }) => {
		const statusColor = theme.colors.status[$color] || theme.colors.status.neutral
		if ($variant === 'solid') return theme.colors.text.inverse
		return statusColor.text
	}};

	border: 1px solid ${({ theme, $color, $variant }) => {
		const statusColor = theme.colors.status[$color] || theme.colors.status.neutral
		if ($variant === 'solid') return 'transparent'
		if ($variant === 'outline') return statusColor.border || statusColor.text
		return statusColor.border || statusColor.bg
	}};

	svg {
		font-size: 1.1em;
		color: ${({ theme, $color, $variant }) => {
			const statusColor = theme.colors.status[$color] || theme.colors.status.neutral
			if ($variant === 'solid') return theme.colors.text.inverse
			return statusColor.icon || statusColor.text
		}};
	}
`

const PillV2 = ({
	children,
	color = 'neutral',
	variant = 'subtle', // 'solid', 'subtle', 'outline'
	size = 'base', // 'small', 'base', 'large'
	round = true, // full border radius vs md radius
	icon,
	className,
	...props
}) => {
	return (
		<PillContainer
			className={className}
			$color={color}
			$variant={variant}
			$size={size}
			$round={round}
			{...props}
		>
			{icon && <span style={{ display: 'flex' }}>{icon}</span>}
			{children}
		</PillContainer>
	)
}

export default PillV2
